import React from 'react';
import { Texto } from './Texto';
export var RenderAditionalInfo = function (_a) {
    var aditionalInfo = _a.aditionalInfo, align = _a.align, fontSize = _a.fontSize, bold = _a.bold;
    return React.createElement(Texto, { texto: aditionalInfo, align: align, fontSize: fontSize, bold: bold });
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/AditionalInfo.tsx
// module id = 1168
// module chunks = 0